export default __webpack_public_path__ + "static/media/systemDesignGuide.392056c2.md";